import { render, staticRenderFns } from "./WorkbenchMediaUpload.vue?vue&type=template&id=b244610a&scoped=true"
import script from "./WorkbenchMediaUpload.vue?vue&type=script&lang=js"
export * from "./WorkbenchMediaUpload.vue?vue&type=script&lang=js"
import style0 from "./WorkbenchMediaUpload.vue?vue&type=style&index=0&id=b244610a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b244610a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b244610a')) {
      api.createRecord('b244610a', component.options)
    } else {
      api.reload('b244610a', component.options)
    }
    module.hot.accept("./WorkbenchMediaUpload.vue?vue&type=template&id=b244610a&scoped=true", function () {
      api.rerender('b244610a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/announcement/components/WorkbenchMediaUpload.vue"
export default component.exports